import gql from "graphql-tag";

export const addClientM = gql`
    mutation AddClient(
        $name: String!,
        $document: String!,
        $email: String!,
        $phone: String!,
        $celphone: String!,
        $branch: ID!
    ){
        addClient(
            name: $name,
            document: $document,
            email: $email,
            phone: $phone,
            celphone: $celphone,
            branch: $branch
        ) {
            _id,
            name
        }
    }
`;

export const updateClientM = gql`
    mutation UpdateClient(
        $_id: ID!,
        $name: String!,
        $document: String!,
        $email: String!,
        $phone: String!,
        $celphone: String!,
        $branch: ID!
    ){
        updateClient(
            _id: $_id,
            name: $name,
            document: $document,
            email: $email,
            phone: $phone,
            celphone: $celphone,
            branch: $branch
        ) {
            _id,
            name
        }
    }
`;

export const removeClientM = gql`
    mutation RemoveClient(
        $_id: ID!
    ){
        removeClient(
            _id: $_id
        ) {
            _id,
            name,
        }
    }
`;


// WEBPACK FOOTER //
// ./src/graphql/mutation/client.js